import {Base} from "@/api/Base"

export class RemainingGetByIdEmp extends Base {
    path = "remainingVacation/getByIdEmp"
}